export default __webpack_public_path__ + "static/media/bulk-gift-cards.497f3d40.webp";